import React from 'react';
import { motion } from 'framer-motion';
import { Countdown } from './ui/Countdown';
export function CountdownUrgency() {
  return <section className="py-12 bg-red-600 text-white border-y-4 border-red-700" data-id="element-35">
      <div className="container mx-auto px-4 text-center" data-id="element-36">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="max-w-3xl mx-auto" data-id="element-37">
          <h2 className="text-2xl md:text-3xl font-black uppercase tracking-wider mb-6" data-id="element-38">
            ⏰ PRECIO DE LANZAMIENTO — CIERRA EN:
          </h2>

          <div className="mb-8" data-id="element-39">
            <Countdown initialHours={23} initialMinutes={26} initialSeconds={57} theme="light" className="shadow-2xl scale-110 md:scale-125 origin-center" data-id="element-40" />
          </div>

          <p className="text-xl font-bold text-red-100 mb-8" data-id="element-41">
            ⚠️ Después sube. No vuelve al precio de lanzamiento.
          </p>

          <div className="bg-red-700/50 rounded-xl p-6 max-w-xl mx-auto border border-red-500/30" data-id="element-42">
            <p className="font-bold mb-3 flex items-center justify-center gap-2" data-id="element-43">
              <span className="w-3 h-3 rounded-full bg-slate-300 animate-pulse" data-id="element-44"></span>
              Cupos al precio de lanzamiento — Quedan pocos
            </p>

            <div className="w-full bg-red-900/50 rounded-full h-4 mb-2 overflow-hidden border border-red-800" data-id="element-45">
              <motion.div initial={{
              width: 0
            }} whileInView={{
              width: '71%'
            }} transition={{
              duration: 1.5,
              ease: 'easeOut'
            }} className="bg-gradient-to-r from-slate-400 to-slate-200 h-4 rounded-full" data-id="element-46"></motion.div>
            </div>
            <p className="text-sm text-red-200 font-medium text-right" data-id="element-47">
              71% tomados
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}